import React from 'react'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { FluidObject } from 'gatsby-image'
import { Image } from 'src/components/atoms/Image'


type Props = {
  imageFluid?: FluidObject
  imageUrl?: string
  title: string
  description: string
}


/**
 * 画像・タイトル・説明のひとかたまり
 */
export const PartnerPointCard: React.VFC<Props> = ({
    imageFluid,
    imageUrl,
    title,
    description,
}) => {
    return (
        <Card>
        {imageFluid ? (
            <RasterImageWrapper>
            <RasterImage imageFluid={imageFluid} />
            </RasterImageWrapper>
        ) : (
            <VectorImage src={imageUrl} alt="" />
        )}
        <Contents>
            <Title as="h3">
            <div>
                {title.split('\n').map(str => (
                <NoLineBreak key={str}>{str}</NoLineBreak>
                ))}
            </div>
            </Title>
            <Description>{description}</Description>
        </Contents>
        </Card>
    )
}

const Card = styled.div`
    display: block;
    align-items: center;
    justify-content: space-between;
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        text-align: left;
        flex-direction: column;
    }
`

const RasterImageWrapper = styled.div`
    max-width: 40%;
    height: auto;
    align-self: flex-start;
    width: 50%;
    margin: 0 auto;
`

const RasterImage = styled(Image)``

const VectorImage = styled.img`
    max-width: 40%;
    height: auto;
    align-self: flex-start;
    margin: calc(${Styles.spacing[4]} * -1) 0 0 calc(${Styles.spacing[4]} * -1);
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        margin: 0;
        max-width: 100%;
    }
`

const Contents = styled.div`
    margin: 0;
    flex: 1;
    min-width: 0;
    text-align: center;
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        margin: 0;
        display: flex;
        flex-direction: column;
    }
`

const Title = styled(Typography)`
    color: ${Styles.color.primary[400]};
    font-size: ${Styles.fontSize[400]};
    font-weight: ${Styles.fontWeight.bold};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    padding: ${Styles.spacing[8]} 0 0;
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        padding: ${Styles.spacing[7]} 0 0;
        font-size: ${Styles.fontSize[500]};
        flex: 1;
        min-width: 0;
        display: block;
        align-items: center;
        justify-content: center;
    }
`

const Description = styled(Typography)`
    margin: ${Styles.spacing[6]} 0 0;
    font-size: ${Styles.fontSize[300]};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        font-size: ${Styles.fontSize[400]};
    }
`
